import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import AuthContext from '../context/auth-context';
import { AppContext } from "../services/AppContext";

import { BsFillPersonLinesFill, BsPhoneFill } from 'react-icons/bs';
import { FaGraduationCap, FaBriefcase, FaDocker, FaFilePdf } from "react-icons/fa";
import { MdArrowBackIos } from 'react-icons/md';

import FormInfoCard from '../components/FormInfoCard';

import DatosPersonales from '../components/Forms/InfoAplicantes/DatosPersonales';
import Contacto from '../components/Forms/InfoAplicantes/Contacto';
import EstudiosSuperiores from '../components/Forms/InfoAplicantes/EstudiosSuperioresList';
import ExperienciaLaboral from '../components/Forms/InfoAplicantes/ExperienciaLaboral';
import AdjuntosDocumentos from '../components/Forms/InfoAplicantes/AdjuntosDocumentos';


import useGetDatosPersonales from '../hooks/useGetDatosPersonales';
import useGetContacto from '../hooks/useGetContacto';
import useGetEducacion from '../hooks/useGetEducacion';
import useGetLaboral from '../hooks/useGetExperienciaLaboral';
import useGetAdjuntosdocs from '../hooks/useGetAdjuntosdocs';

import axios from 'axios';


const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};

const InformacionAplicante = () => {
    const { appValues, setAppValues } = useContext(AppContext);

    const navigate = useNavigate();
    if( !appValues.infoAplicanteEnabled )
        navigate('/', { replace: true });
    
    const [showDatosPersonales, setShowDatosPersonales] = useState(true);
    const [showContacto, setShowContacto] = useState(false);
    const [showEstudiosSuperiores, setShowEstudiosSuperiores] = useState(false);
    const [showExperienciaLaboral, setShowExperienciaLaboral] = useState(false);
    const [showAdjuntos, setShowAdjuntos] = useState(false);


    /*Agregando variable para manejar el estado de habilitación del click*/ 
  
 /*   const [DatosPersonalesClick, setDatosPersonalesClick] = useState(false);
    const [ContactoClick, setContactoClick] = useState(true);
    const [EstudiosSuperioresClick, setEstudiosSuperioresClick] = useState(true);
    const [ExperienciaLaboralClick, setExperienciaLaboralClick] = useState(true);
*/
    
    const authContext = useContext(AuthContext);

    const datosPersonales = useGetDatosPersonales(authContext.token);
    const contacto = useGetContacto(authContext.token);
    const educacion = useGetEducacion(authContext.token);
    const laboral   = useGetLaboral(authContext.token);
    const adjuntos   = useGetAdjuntosdocs(authContext.token);



    const onClickHandlerDatosPersonales = () => {
        setShowDatosPersonales( true );
        setShowContacto( prev => prev ? !prev:prev );
        setShowEstudiosSuperiores( prev => prev ? !prev:prev );
        setShowExperienciaLaboral( prev => prev ? !prev:prev );        
        setShowAdjuntos(  prev => prev ? !prev:prev);


    };

    const onClickHandlerContacto = () => {
        setShowDatosPersonales( prev => prev ? !prev:prev );
        setShowContacto( true );
        setShowEstudiosSuperiores( prev => prev ? !prev:prev );
        setShowExperienciaLaboral( prev => prev ? !prev:prev );        
        setShowAdjuntos(  prev => prev ? !prev:prev);


    };

    const onClickHandlerEstudiosSuperiores = () => {
        setShowDatosPersonales( prev => prev ? !prev:prev );
        setShowContacto( prev => prev ? !prev:prev );
        setShowEstudiosSuperiores( true );
        setShowExperienciaLaboral( prev => prev ? !prev:prev );
        setShowAdjuntos(  prev => prev ? !prev:prev);

    };

    const onClickHandlerExperienciaLaboral = () => {
        setShowDatosPersonales( prev => prev ? !prev:prev );
        setShowContacto( prev => prev ? !prev:prev );
        setShowEstudiosSuperiores( prev => prev ? !prev:prev );
        setShowExperienciaLaboral( true );
        setShowAdjuntos(  prev => prev ? !prev:prev);

    };

    const onClickHandlerAdjuntos = () => {
        setShowDatosPersonales( prev => prev ? !prev:prev );
        setShowContacto( prev => prev ? !prev:prev );
        setShowEstudiosSuperiores( prev => prev ? !prev:prev );
        setShowExperienciaLaboral(  prev => prev ? !prev:prev );        
        setShowAdjuntos( true );
    };


    const estadoDatosPersonales = appValues.datosPersonales ? "completado":"pendiente";
    const estadoContacto = appValues.contacto ? "completado":"pendiente";
    const estadoEstudiosSuperiores = appValues.estudiosSuperiores ? "completado":"pendiente";
    const estadoExperienciaLaboral = appValues.experienciaLaboral ? "completado":"pendiente";   
    const estadoAdjuntos = appValues.documentosAdjuntos ? "completado":"pendiente";



    /*******************************************************************/
    //true significa que esa parte si es clickeable
    const DatosPersonalesClick = true ; //; appValues.datosPersonales ? false;
    let ContactoClick = false ;
    let EstudiosSuperioresClick = false;
    let ExperienciaLaboralClick = false;
    let AdjuntosClick = false;
    //appValues.contacto ? true:false;
    // EstudiosSuperioresClick = appValues.estudiosSuperiores ? true:false;
    //const ExperienciaLaboralClick = appValues.experienciaLaboral ? true:false;

    /*ContactoClick = false;
    EstudiosSuperioresClick = false;
    ExperienciaLaboralClick = false;*/
    

    /* Para que contacto click sea clickeable debe haber completado datos personales y su estado debe ser pendiente */

    if((estadoDatosPersonales === "completado") && ( estadoContacto === "pendiente" )){
        ContactoClick = true;
        EstudiosSuperioresClick = false;
        ExperienciaLaboralClick = false;
        AdjuntosClick = false;
    }

    if((estadoDatosPersonales === "completado") && ( estadoContacto === "completado" ) && ( estadoEstudiosSuperiores === "pendiente" )){
        ContactoClick = true;
        EstudiosSuperioresClick = true;
        ExperienciaLaboralClick = false;
        AdjuntosClick=false;
    } 

    if((estadoDatosPersonales === "completado") && ( estadoContacto === "completado" ) && ( estadoEstudiosSuperiores === "completado" ) &&
    
    (estadoDatosPersonales ==="completado" || "pendiente" )){
        ContactoClick = true;
        EstudiosSuperioresClick = true;
        ExperienciaLaboralClick = true;
        AdjuntosClick = false;
    } 


    if((estadoDatosPersonales === "completado") && ( estadoContacto === "completado" ) && ( estadoEstudiosSuperiores === "completado" ) &&
    (estadoExperienciaLaboral ==="completado") &&
    (estadoDatosPersonales ==="completado" || "pendiente" )){
        ContactoClick = true;
        EstudiosSuperioresClick = true;
        ExperienciaLaboralClick = true;
        AdjuntosClick = true;
    } 


           
    const validarFormsCompletados = ( formName ) => {

        if( appValues.datosPersonales && appValues.contacto && appValues.estudiosSuperiores && appValues.experienciaLaboral && appValues.documentosAdjuntos ){
            Swal.fire({
                icon: 'success',
                title: '¡Información completada!',
                showCancelButton: true,
                cancelButtonText: 'Seguir editando',
                confirmButtonText: 'Continuar'
            }).then((result) => {
                if( result.isConfirmed ){
                    navigate('/', { replace: true });
                }
            });

          


        } else if( formName === 'datos-personales' || formName === 'contacto' || formName === 'experiencia-laboral'|| formName === 'adjuntos-docs'  ) {
            scrollToTop();

            let textFormCompletado = "";

            let mostrarmensajecompletado=""

            if( formName === 'datos-personales' ){
                textFormCompletado = "Se guardaron los datos personales.";
            } else if( formName === 'contacto' ){
                textFormCompletado = "Se completó la información de contacto.";
            } else if( formName === 'estudios-superiores' ){
                textFormCompletado = "Se guardaron los estudios superiores.";
            } else if( formName === 'experiencia-laboral' ){
                textFormCompletado = "Se guardó la experiencia laboral (en este momento ya puede programar la fecha de su examén de admisión).";
            }else if( formName === 'adjuntos-docs' ){
                textFormCompletado = "Se guardaron los documentos de admisiones.";
                mostrarmensajecompletado = "1";
            }

            if(mostrarmensajecompletado==="1"){

                Swal.fire({
                    icon: 'success',
                    title: '¡Información completada!',
                    showCancelButton: true,
                    cancelButtonText: 'Seguir editando',
                    confirmButtonText: 'Continuar'
                }).then((result) => {
                    if( result.isConfirmed ){
                        navigate('/', { replace: true });
                    }
                });
    
                /////////////////////Aqui podemos llamar al endpoint con ID_TOKEN Y formularioCompletado? 
                const form_data = new FormData();
               form_data.append('idToken', authContext.token);
               form_data.append('formulario_completado', 1);
        
                axios.post(process.env.REACT_APP_API_URL, form_data)
                .then(res => {
                    console.log(res);
                })
                .catch((error) => {
                    console.log(error)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrió un problema, intentelo más tarde',
                        showConfirmButton: false,
                        timer: 3500
                    });
                })

            }
            else{ 

                //adjuntos-docs
            
            Swal.fire({
                icon: 'success',
                title: '¡Datos guardados!',
                text: textFormCompletado,
                showCancelButton: true,
                cancelButtonText: 'Seguir editando',
                confirmButtonText: 'Continuar'
            }).then((result) => {
                if( result.isConfirmed ){
                    if( formName === 'datos-personales' ){
                        onClickHandlerContacto();
                    } else if( formName === 'contacto' ){
                        onClickHandlerEstudiosSuperiores();
                    } else if( formName === 'estudios-superiores' ){
                        onClickHandlerExperienciaLaboral();
                    } else if( formName === 'experiencia-laboral' ){
                        onClickHandlerAdjuntos();
                    }
                    else if( formName === 'adjuntos-docs'){
                        onClickHandlerDatosPersonales();
                    }
                }
            });

        

        }

        }
    };


    useEffect(() => {
        if(datosPersonales !== undefined && "fecha_nacimiento" in datosPersonales && datosPersonales.fecha_nacimiento !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.datosPersonales ? prev.perfil : prev.perfil+20;
                    return { ...prev, datosPersonales: true, perfil };
                }
            );
        }

        if(contacto !== undefined && "direccion" in contacto && contacto.direccion !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.contacto ? prev.perfil : prev.perfil+20;
                    return { ...prev, contacto: true, perfil };
                }
            );
        }

        if(!!educacion && Object.keys(educacion).length > 1){
            setAppValues(
                prev => {
                    let perfil = prev.estudiosSuperiores ? prev.perfil : prev.perfil+20;
                    return { ...prev, estudiosSuperiores: true, perfil };
                }
            );
        }

        if(laboral !== undefined && "trabaja" in laboral &&laboral.trabaja !== ""){
            setAppValues(
                prev => {
                    let perfil = prev.experienciaLaboral ? prev.perfil : prev.perfil+20;
                    return { ...prev, experienciaLaboral: true, perfil };
                }
            );
        }


        // Agregando aqui que deben existir los 5 documentos para ser tomado como completo
        if(adjuntos !== undefined && "identificacion" in adjuntos && adjuntos.identificacion !== ""
            && "curriculum" in adjuntos && adjuntos.curriculum !== ""
            && "recomendacion" in adjuntos && adjuntos.recomendacion !== ""
            && "recomendacion2" in adjuntos && adjuntos.recomendacion2 !== ""
            && "titulo" in adjuntos && adjuntos.titulo !== ""
            && "historialnotas" in adjuntos && adjuntos.historialnotas !== ""
        ){
            setAppValues(
                prev => {
                    let perfil = prev.documentosAdjuntos ? prev.perfil : prev.perfil+20;
                    return { ...prev, documentosAdjuntos: true, perfil };
                }
            );
        }


        


        if
        (
            datosPersonales !== undefined && "fecha_nacimiento" in datosPersonales && datosPersonales.fecha_nacimiento !== "" &&
            contacto !== undefined && "direccion" in contacto && contacto.direccion !== "" &&
            educacion !== undefined && Object.keys(educacion).length > 1 &&
            laboral !== undefined && "trabaja" in laboral &&laboral.trabaja !== "" &&
            adjuntos !== undefined && "identificacion" in adjuntos && adjuntos.identificacion !== ""
            && "curriculum" in adjuntos && adjuntos.curriculum !== ""
            && "recomendacion" in adjuntos && adjuntos.recomendacion !== ""
            && "recomendacion2" in adjuntos && adjuntos.recomendacion2 !== ""
            && "titulo" in adjuntos && adjuntos.titulo !== ""
            && "historialnotas" in adjuntos && adjuntos.historialnotas !== ""

        )
        {
            setAppValues(
                prev => {
                    return { ...prev, infoAplicante: true};
                }
            );
        }else {
            setAppValues(
                prev => {
                    return { ...prev, infoAplicante: false};
                }
            );
        }
    }, [
        datosPersonales, contacto, educacion, laboral, adjuntos, setAppValues
    ]);

    return (
        <>
            {/* BUTTON REGRESAR */}
            <div className="row py-5">
                <div className="col-lg-8 offset-lg-2 mt-2">
                    <Link className="btn btn-outline-light border border-2 border-light shadow" style={{fontWeight: "500"}} to='/'>
                        <MdArrowBackIos/> Regresar
                    </Link>
                </div>
            </div>

            <div className="row">

                <div className="col-lg-3 offset-lg-2">
                    <div className="row">
                        {/* DATOS PERSONALES */}
                        {/*onClick={onClickHandlerDatosPersonales} */}
                        <div className="col-sm-12 mb-4">
                            <FormInfoCard 
                                estado={estadoDatosPersonales} 
                                titulo="Datos personales" 
                                texto=""
                                icon={BsFillPersonLinesFill}
                                onClick={!DatosPersonalesClick ? () => {} : onClickHandlerDatosPersonales}
                                onHover={!showDatosPersonales} 
                                className={showDatosPersonales ? "border border-3 border-info border-opacity-50":""} />
                        </div>

                        {/* CONTACTO */}
                        <div className="col-sm-12 mb-4">
                            <FormInfoCard 
                                estado={estadoContacto} 
                                titulo="Contacto" 
                                texto=""
                                icon={BsPhoneFill}
                                onClick={!ContactoClick ? () => {} : onClickHandlerContacto}
                                onHover={!showContacto} 
                                className={showContacto ? "border border-3 border-info border-opacity-50":""} />
                        </div>

                        {/* ESTUDIOS SUPERIORES */}
                        <div className="col-sm-12 mb-4">
                            <FormInfoCard
                                estado={estadoEstudiosSuperiores}
                                titulo="Estudios superiores"
                                texto=""
                                icon={FaGraduationCap}
                                onClick={!EstudiosSuperioresClick ? () => {} : onClickHandlerEstudiosSuperiores}
                                onHover={!showEstudiosSuperiores} 
                                className={showEstudiosSuperiores ? "border border-3 border-info border-opacity-50":""} />
                        </div>

                        {/* EXPERIENCIA LABORAL */}
                        <div className="col-sm-12 mb-4">
                            <FormInfoCard
                                estado={estadoExperienciaLaboral}
                                titulo="Experiencia laboral"
                                texto=""
                                icon={FaBriefcase}
                                onClick={!ExperienciaLaboralClick ? () => {} : onClickHandlerExperienciaLaboral}
                                onHover={!showExperienciaLaboral} 
                                className={showExperienciaLaboral ? "border border-3 border-info border-opacity-50":""} />
                        </div>

                        {/* ADJUNTOS DOCUMENTOS*/}
                           <div className="col-sm-12 mb-4">
                            <FormInfoCard
                                estado={estadoAdjuntos}
                                titulo="Adjuntos"
                                texto=""
                                icon={FaFilePdf}
                                onClick={!AdjuntosClick ? () => {} : onClickHandlerAdjuntos  }
                                onHover={!showAdjuntos} 
                                className={showAdjuntos ? "border border-3 border-info border-opacity-50":""} />
                        </div>

                    </div>
                </div>

                <div className="col-sm-12 col-lg-5">
                    {showDatosPersonales    && <DatosPersonales     onCompletado={validarFormsCompletados} />}
                    {showContacto           && <Contacto            onCompletado={validarFormsCompletados} />}
                    {showEstudiosSuperiores && <EstudiosSuperiores  onCompletado={validarFormsCompletados} />}
                    {showExperienciaLaboral && <ExperienciaLaboral  onCompletado={validarFormsCompletados} />}                    
                    {showAdjuntos           && <AdjuntosDocumentos  onCompletado={validarFormsCompletados} />}

                </div>
            </div>
        </>
    )
}

export default InformacionAplicante;